export enum DigitalSignageDateOptions {
  AllTheTime = "All the time",
  Custom = "Custom"
}